export default "__VITE_ASSET__CVB4tgOU__"